<template>
  <section
    class="
      f-loader
      fixed
      top-0
      left-0
      right-0
      bottom-0
      flex
      items-center
      justify-center
      z-50
      bg-velux-grey-900 bg-opacity-70
    "
  >
    <div class="-mt-40 mx-auto mb-10 w-full text-center p-10">
      <div class="w-40 h-40 mx-auto">
        <svg
          class="animate-spin m-0 mx-auto"
          width="104"
          height="104"
          viewBox="0 0 104 104"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M52 104C80.7188 104 104 80.7188 104 52C104 23.2812 80.7188 0 52 0C23.2812 0 0 23.2812 0 52C0 80.7188 23.2812 104 52 104ZM52 92C74.0918 92 92 74.0914 92 52C92 29.9086 74.0918 12 52 12C29.9082 12 12 29.9086 12 52C12 74.0914 29.9082 92 52 92Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M52 104C80.7188 104 104 80.7188 104 52H92C92 74.0914 74.0918 92 52 92V104Z"
            fill="#EE0000"
          />
        </svg>
      </div>
      <p class="f-loader__text"><slot></slot></p>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      loadingTransitionName: "fade"
    };
  }
};
</script>
